import React from 'react';

// third-party
import ScrollAnimation from 'react-animate-on-scroll';

// project-imports
import { SERIES } from '../../../constants';
import { GoogleAnalyticsEnum, triggerFunction } from '../../../utils/google-analytics';
import { Link } from 'react-router-dom';
import { toUpperSnake } from '../../../utils';
import Image from '../../../common/footer/Images/Image';

const InterviewCategories = ({ wrapperClass, styleClass, data }) => {

    return (
        <div className={`row ${wrapperClass || 'y-gap-15 mt--25'}`}>
            {(data || []).map((data, i) => (
                <ScrollAnimation
                    animateIn="fadeInUp"
                    animateOut="fadeInOut"
                    className={`col-lg-4 col-md-6 col-12 ${styleClass ? styleClass : ''} `}
                    animateOnce={true}
                    key={i}
                >
                    <div className="service-card service-card-5">
                        <div className="inner">
                            <div className="icon">
                                <Image src={data?.thumbnail} alt="Thumbnail" fill />
                            </div>
                            <div className="content">
                                <h6 className="title">
                                    <Link to={`/interview-questions/${data?.slug}`}
                                        onClick={() =>
                                            triggerFunction(
                                                GoogleAnalyticsEnum.LINK,
                                                GoogleAnalyticsEnum.INTERVIEW_QUESTION_CATEGORY + `_HOME_${toUpperSnake(data?.name)} `
                                            )
                                        }>
                                        {data?.name}
                                    </Link>
                                </h6>
                                <p className="description">{data?.series?.length} {SERIES}</p>
                            </div>
                        </div>
                    </div>
                </ScrollAnimation>
            ))}
        </div>
    )
}

export default InterviewCategories;